import { render } from "./SearchPostCode.vue?vue&type=template&id=6a062675&scoped=true"
import script from "./SearchPostCode.vue?vue&type=script&lang=js"
export * from "./SearchPostCode.vue?vue&type=script&lang=js"

import "./SearchPostCode.vue?vue&type=style&index=0&id=6a062675&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a062675"]])

export default __exports__